/* eslint-disable max-len */
/**
 * Spanish translations.
 */
export default {
  ACTION: {
    MESSAGE_DETAILS: 'Detalles del mensaje',
    OK: 'OK'
  },
  ERROR: {
    ERROR: 'Error',
    FETCH_DATA: 'Recuperar datos',
    NO_ORDER: 'No se puede realizar el pedido'
  },
  HEADER: {
    DATE: 'Fecha',
    MESSAGE: 'Mensaje',
    NAME: 'Nombre de cliente',
    ORDER_CODE: 'Código de pedido',
    ORDER_DATE: 'Fecha de pedido',
    ORDER_ID: 'Pedido',
    ORDER_VALUE: 'Importe',
    PAYMENT_DATE: 'Fecha de pago',
    PAYMENT_STATE: 'Estado de pago',
    PRICE: 'Precio',
    VALUE: 'Importe'
  },
  LABEL: {
    COPIED: 'Copiado!',
    EXPORT: 'Exportar',
    GIVEWAY_DATE: 'Fecha del sorteo:',
    MONTH: 'Mes',
    ORDER_PRIZE_MSG: 'El orden sorteado fue:',
    PAYED: 'Pagado',
    PRIZE: 'Giveaway',
    RAFFLE: 'Giveaway',
    UNPAYED: 'Sin pagar',
    UNTIL: 'until',
    YEAR: 'Año'
  },
  SENTENCE: {
    NO_ROWS_ORDER_MESSAGES: 'No hay mensajes',
    NO_ROWS_ORDER_MESSAGES_DESCRIPTION: 'No hay mensajes de clientes (aún).',
    NO_ROWS_ORDERS: 'No hay pedidos',
    NO_ROWS_ORDERS_DESCRIPTION: 'No hay pedidos (aún).'
  },
  SUCCESS: {
    SUCCESS: 'Acción realizada correctamente'
  },
  TOOLTIP: {
    DATE: 'Fecha',
    ORDER_CODE: 'Código de pedido',
    ORDER_ID: 'Pedido',
    PAYMENT_DATE: 'Fecha de pago',
    PAYMENT_STATE: 'Estado de pago',
    PRICE: 'Precio',
    VALUE: 'Importe'
  }
};
